/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
export const fetchOptions = async (
    fetchFunction: () => Promise<any>,
    setFunction: (data: any) => void
) => {
    try {
        const resp = await fetchFunction();
        if (resp?.status === 200 || resp?.status === 201) {
            if (resp?.data) {
                setFunction(resp.data);
            }
        }
    } catch (err) {
        console.log(err);
    }
};

export const fetchOptionsReturn = async (fetchFunction: () => Promise<any>) => {
    try {
        const resp = await fetchFunction();
        if (resp?.status === 200 || resp?.status === 201) {
            if (resp?.data) {
                return resp.data;
            }
        }
    } catch (err) {
        console.log(err);
    }
};

export const fetchOptionsWithParameter = async (
    fetchFunction: (parameter: string) => Promise<any>,
    setFunction: (data: any) => void,
    parameter: string
) => {
    try {
        const resp = await fetchFunction(parameter);
        if (resp?.status === 200 || resp?.status === 201) {
            if (resp?.data) {
                setFunction(resp.data);
            }
        }
    } catch (err) {
        console.log(err);
    }
};

export const returnOptionsWithParameter = async (
    fetchFunction: (parameter: string) => Promise<any>,
    parameter: string
) => {
    try {
        const resp = await fetchFunction(parameter);
        if (resp?.status === 200 || resp?.status === 201) {
            if (resp?.data) {
                return resp.data;
            }
        }
    } catch (err) {
        console.log(err);
    }
};
